import React, { useState, useEffect } from 'react'
import { ReactComponent as BoxesIcon } from '@/assets/icons/boxes-icon.svg'
import { ReactComponent as BagdeIcon } from '@/assets/icons/badge-icon.svg'
import CommonsService from '@/services/commons.service'
import threadsService from '@/app-domains/threads/threads.service'

import {
  KBarPortal,
  KBarPositioner,
  KBarAnimator,
  KBarSearch,
  useMatches,
  KBarResults,
  useRegisterActions,
  useKBar,
  Priority,
  createAction
} from 'kbar'

import boxesService from '@/app-domains/boxes/boxes.service'
import labelsService from '@/app-domains/labels/labels.service'

import './KbarInput.sass'

const actionsBasic = [
  {
    id: 'history',
    name: 'History',
    shortcut: ['b'],
    keywords: 'history',
    section: 'Navigation',
    perform: () => (CommonsService.goToPage('/history')),
  },
  {
    id: 'settings',
    name: 'Settings',
    shortcut: ['c'],
    keywords: 'settings',
    section: 'Navigation',
    perform: () => (CommonsService.goToPage('/history')),
  }
]

function RenderResults () {
  const { results } = useMatches()
  const state = useKBar(state => state)
  const value = state.searchQuery
  // results = results.filter(action => typeof item === 'string' || action?.name?.includes(value))

  if (value) {
    const action = createAction({
      id: value,
      name: 'Text: ' + value,
      shortcut: ['b'],
      keywords: value,
      section: 'Text',
      priority: Priority.HIGH,
      perform: () => {
        if (CommonsService.getCurrentPath() !== '/') {
          CommonsService.goToPage('/', true)
          setTimeout(() => {
            threadsService.applyFilterFor('text', `Search: ${value}`, value.toLowerCase())
            state.query.toggle()
          }, 200)
        } else {
          threadsService.applyFilterFor('text', `Search: ${value}`, value.toLowerCase())
          state.query.toggle()
        }
      },
    })
    if (!results.find((action) => action.id === value)) results.unshift('Text', action)
  }
  return (
    <KBarResults
      // items={value ? results.filter(action => typeof item === 'string' || action?.name?.includes(value)) : results}
      items={results}
      onRender={({ item, active }) => {
        if (typeof item === 'string') {
          return <div className='kbar-list-separator'>{item}</div>
        } else if (item.section === 'Boxes' || item.section === 'Labels') {
          return <div className='kbar-list-item' style={{ background: active ? '#eee' : 'transparent' }}>
            <span className='label-icon'>
              {item.section === 'Boxes' ? <BoxesIcon /> : <BagdeIcon />}
            </span>
            <span className='label-name'>
              {item?.name}
            </span>
          </div>
        } else {
          if (item.section === 'Text') {
            return <div className='kbar-list-item' onClick={item.perform} style={{ background: active ? '#eee' : 'transparent' }}>{item?.name}</div>
          }
          return <div className='kbar-list-item' style={{ background: active ? '#eee' : 'transparent' }}>{item?.name}</div>
        }
      }}
    />
  )
}

function Search () {
  const [actions, setActions] = useState(actionsBasic)

  useEffect(() => {
    const newActions = actions
    const boxesFound = boxesService.findBoxesByQuery('')
    boxesFound?.forEach((box) => {
      newActions.push({
        id: box.nickName,
        name: box.nickName,
        shortcut: ['b'],
        keywords: box.nickName,
        section: 'Boxes',
        perform: () => {
          if (CommonsService.getCurrentPath() !== '/') {
            CommonsService.goToPage('/', true)
            setTimeout(() => threadsService.applyFilterFor('Box', box.boxalias || box.boxname, box.composedid), 200)
          } else {
            threadsService.applyFilterFor('Box', box.boxalias || box.boxname, box.composedid)
          }
        },
      })
    })
    for (const [key, value] of Object.entries(labelsService.getLabelsFromStore())) {
      newActions.push({
        id: key,
        name: value.name,
        shortcut: ['b'],
        keywords: value.name,
        section: 'Labels',
        perform: () => {
          if (CommonsService.getCurrentPath() !== '/') {
            CommonsService.goToPage('/', true)
            setTimeout(() => threadsService.applyFilterFor('Label', value.name, value.composedid, false), 200)
          } else {
            threadsService.applyFilterFor('Label', value.name, value.composedid, false)
          }
        },
      })
    }
    setActions(newActions)
  }, [])

  useRegisterActions(actions, [actions])
  return <KBarSearch className='kbar-search'/>
}

export function KbarInput () {
  return <KBarPortal>
    <KBarPositioner className='kba-positioner'>
      <KBarAnimator className='kba-animator'>
        <Search />
        <RenderResults />
      </KBarAnimator>
    </KBarPositioner>
  </KBarPortal>
}
